<template>
	<div
		class="option-menu-item"
		:class="customCssWidget"
		v-tooltip="tooltip"
		@click="$emit('click', $event)"
	>
		<div :class="iconClass"></div>
	</div>
</template>
<script>
export default {
	name: 'RowActionIconButton',
	props: {
		iconClass: {
			type: [String, Array, Object],
			required: true,
		},
		tooltip: {
			type: String,
			default: '',
		},
		customCssWidget: '',
	},
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.option-menu-item {
	width: 28px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid $ms-border-color;
	border-radius: $base-border-radius;
	background-color: $white;
	cursor: pointer;
	outline: none;
	&:hover {
		background-color: $ms-color-neutral-200;
	}
}

.option-menu-item-custom {
	width: 28px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	outline: none;
	border: none;
}
</style>
